module.exports = __webpack_public_path__ + "static/media/tshirt-back-min.f70a67c6.png";